require('./retailLoanStepThree.scss');
require('./retailLoanStepThree.override.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@components
const RetailLoanAccounts = require('../../contractRetailLoan/retailLoanAccounts/retailLoanAccounts');
const RetailLoanConfirmAddress = require('../../contractRetailLoan/retailLoanConfirmAddress/retailLoanConfirmAddress');
const RetailLoanPickupAddress = require('../../contractRetailLoan/retailLoanPickupAddress/retailLoanPickupAddress');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const { OKButton } = require('components/commons/OKButton/OKButton');
const download = require('downloadjs');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');

// @constants
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
const { MULTIPLE_OPERATIONS } = require('constants/operationTypes');
const {
    CONTRACT_DOCUMENT,
    INE_DOCUMENT,
    retailLoanProposition,
    retailLoanDoTaggin,
    INE_DOCUMENT_NAME
} = require('../../../../loansConstants/index');

const {
    OPEN_MARKET_BANK_ACCOUNT_EVENT_TAG,
    OPEN_MARKET_DOCUMENT_PRINT_EVENT_TAG,
    OPEN_MARKET_DOCUMENT_DOWNLOAD_EVENT_TAG
} = require('constants/tagging');
// @Utilities
const { getFormattedString } = require('utilities/currencyHelper');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { formatDate } = require('utilities/dateHelper');
const { buildLoadStepRetailLoanInfo, isRetailAddressDelivery } = require('../../../../loansUtilities/loansHelper');
const { recordLinkV2, PROC_START, PROC_STEP } = require('utilities/tagging');
const translationContractLoanPdfViewerINE = require("../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations")
const { NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');

class RetailLoanStepThree extends React.Component {

    constructor(props) {
        super(props);
        this.onSelectedAccount = this.onSelectedAccount.bind(this);
        this.handleAgreeCheckboxChange = this.handleAgreeCheckboxChange.bind(this);
        this.handlePdfActionClick = this.handlePdfActionClick.bind(this);
        this.handleOpenPdfNewTab = this.handleOpenPdfNewTab.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleAgreeCheckModal = this.handleAgreeCheckModal.bind(this);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);

    }
    handleOpenPdfNewTab() {
        const { immRetailLoan } = this.props;
        const document = immRetailLoan.get('fileRetailLoanINEDocument', "");
        if (document) {
            openBase64pdfInPrintWindow(document, true);
        }
    }

    componentWillUnmount() {
         const { immFlagBasedFeatures } = this.props;
        const newRetailFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES)
        if (!newRetailFF) {
            this.props.resetAgreeThirdStep();
        }
    }

    getOperationParams(accountId) {
        const { immAccounts, immRetailLoan } = this.props;
        const immProducts = immRetailLoan.get('products');
        const selectedItemId = immRetailLoan.get('purpose');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const proposition = immRetailLoan.get('proposition');
        const selectedAccount = accountId ? accountId : immRetailLoan.get('selectedAccount');
        const newProduct = immAccounts.getIn(['byId', selectedAccount, 'newProduct']);
        const newContractNumber = immAccounts.getIn(['byId', selectedAccount, 'newContractNumber']);
        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + newProduct + newContractNumber;

        const amount = immSelectedItem.get('field_total_product_price');
        const currency = immRetailLoan.get('currency');

        const propositionYear = proposition.get('propositionYear');
        const propositionNumber = proposition.get('propositionNumber');
        const optional1 = API_ENTERPRISE_NUMBER + API_CENTER + propositionYear + propositionNumber;
        const destinationAccount = immRetailLoan.get('destinationAccount');

        return [
            {
                serviceCode: retailLoanProposition.FORMALIZE_OPERATION,
                originAccount,
                ammount: amount,
                currency,
                optional1
            },
            {
                serviceCode: retailLoanProposition.TRANSFER_OPERATION,
                originAccount,
                destinationAccount,
                ammount: amount,
                currency
            }
        ];
    }

    onSelectedAccount(accountId) {
        const { immRetailLoan, setSelectedAccount, processRequestConfiguration } = this.props;
        const operationParams = this.getOperationParams(accountId);
        const proposition = immRetailLoan.get('proposition');
        const agreeThirdStep = immRetailLoan.get('agreeThirdStep');

        this.handleAccountSelectionTaggings();
        setSelectedAccount(accountId);

        if (proposition.get('success') && agreeThirdStep) {
            processRequestConfiguration(MULTIPLE_OPERATIONS, operationParams);
        }
    }

    handleAccountSelectionTaggings() {
        const { immRetailLoan } = this.props;
        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const visibleStep = immRetailLoan.get('visibleStep');
        const customDataEvent = {
            categoriaEvento: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
            accionEvento: OPEN_MARKET_BANK_ACCOUNT_EVENT_TAG,
            etiquetaEvento: immSelectedItem.get('title'),
            pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
            ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
        };
        const customData = {
            ...customDataEvent,
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "address",
        };
        recordLinkV2(customData);
    }

    buildAccounts() {
        const { immAccounts, immRetailLoan } = this.props;

        return (
            <RetailLoanAccounts
                immAccounts={immAccounts}
                immRetailLoan={immRetailLoan}
                setSelectedAccount={this.onSelectedAccount}
            />
        );
    }

    buildAddress() {
        const { immRetailLoan, immProfile, email } = this.props;
        const isSelected = immRetailLoan.getIn(['personalData', 'isSelected']);
        const personalData = isSelected ? immRetailLoan.get('personalData') : immRetailLoan.get('otherAddress');

        return (
            <RetailLoanConfirmAddress
                className="retail-loan-step-three__address"
                phoneText="contractRetailLoanStepThree-phoneNumber"
                email={email}
                immProfile={immProfile}
                immAddress={personalData}
            />
        );
    }

    buildPickupAddress() {
        const { immRetailLoan } = this.props;

        return (
            <RetailLoanPickupAddress
                immOffice={immRetailLoan.get('selectedPickup')}
            />
        )
    }

    buildBikeFields() {
        const address = this.buildAddress();
        const pickupAddress = this.buildPickupAddress();

        return [
            {
                title: formatText('contractRetailLoanStepThree-contractRetailLoanStepThree_billingAddress'),
                bodyText: address
            },
            {
                title: formatText('contractRetailLoanStepThree-contractRetailLoanStepThree_pickupAddress'),
                bodyText: pickupAddress
            }
        ];
    }

    buildOtherProductFields(immSelectedItem) {
        const deliveryDate = formatDate(immSelectedItem.get('deliveryDate'));
        const address = this.buildAddress();

        return [
            {
                title: formatText('contractRetailLoanStepThree-deliveryDate'),
                bodyText: deliveryDate
            },
            {
                title: formatText('contractRetailLoanStepThree-address'),
                bodyText: address
            }
        ];
    }

    buildSummaryInfo(immSelectedItem) {
        const { immRetailLoan } = this.props;

        const deliveryType = immSelectedItem.get('field_pickup_option');
        let decimalsLength = immSelectedItem.get('field_total_product_price') - Math.floor(immSelectedItem.get('field_total_product_price'));
        const amount = getFormattedString({
            amount: immSelectedItem.get('field_total_product_price'),
            currency: immRetailLoan.get('currency'),
            decimalsLength: decimalsLength > 0 ? 2 : 0
        });

        const term = formatText('contractRetailLoanStepThree-termMonths', [immRetailLoan.get('selectedTerm')]);
        const payment = getFormattedString(immRetailLoan.get('installment'))

        const fieldsLeft = [
            {
                title: formatText('contractRetailLoanStepThree-payment'),
                bodyText: payment
            },
            {
                title: formatText('contractRetailLoanStepThree-amount'),
                bodyText: amount
            },
            {
                title: formatText('contractRetailLoanStepThree-term'),
                bodyText: term
            }
        ];

        const fieldsRight = isRetailAddressDelivery(deliveryType) ?
            this.buildOtherProductFields(immSelectedItem) : this.buildBikeFields();

        const mapFields = (field, index) => {
            return (
                <OKInformativeListItem
                    className="retail-loan-step-three__list-item"
                    key={field.title + index}
                    title={field.title}
                    bodyText={field.bodyText}
                />
            );
        };

        const infoItems = fieldsLeft.map(mapFields);
        const addressItems = fieldsRight.map(mapFields);

        return (
            <div className="row">
                <div className="col-xs-6">
                    <OKInformativeList columns={1}>
                        {infoItems}
                    </OKInformativeList>
                </div>
                <div className="col-xs-6 retail-loan-step-three__right-content">
                    <OKInformativeList columns={1}>
                        {addressItems}
                    </OKInformativeList>
                </div>
            </div>
        );
    }



    handleAgreeCheckboxChange() {
        this.props.setAgree();
    }

    handleCheckboxDownloadEvents(event, docType) {
        let value;
        this.handleLabelTaggings(docType);
        if (docType === INE_DOCUMENT) {
            const { downloadINEDocument } = this.props;
            downloadINEDocument();
        } else {
            const { downloanRetailLoanContractDocument } = this.props;
            downloanRetailLoanContractDocument();
        }
        return value;
    }

    handleLabelTaggings(docType) {
        const { immRetailLoan } = this.props;
        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const visibleStep = immRetailLoan.get('visibleStep');
        const customData = {
            categoriaEvento: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
            accionEvento: docType === INE_DOCUMENT
                ? formatText('contractRetailLoanStepThree-contractRetailLoanStepThree_contractRetailLoanIneDocument')
                : formatText('contractRetailLoanStepThree-contractRetailLoanStepThree_contractRetailLoanContractDocument'),
            etiquetaEvento: immSelectedItem.get('title'),
            pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
            ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
        };

        recordLinkV2(customData);
    }

    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={event => this.handleCheckboxDownloadEvents(event, docType)}
                modifier="link-emphasize"
                autoHeight
                loading={false}
            >
                {documentName}
            </OKButton>
        )
    }

    buildCheckboxLabel(poeditorPrefix) {
        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${poeditorPrefix}_${key}`;
        };
        const splitMessage = formatText(getPoEditorKey(`contractRetailLoanAgreeCheckboxLabel`)).split('%s');

        const injectedLinks = [
            { docType: INE_DOCUMENT, text: getPoEditorKey('contractRetailLoanIneDocument') },
            { docType: CONTRACT_DOCUMENT, text: getPoEditorKey('contractRetailLoanContractDocument') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }

    handlePdfActionClick(isDocumentActionDownload) {
        const { immRetailLoan, onDownloadDocument, onPrintDocument } = this.props;
        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const visibleStep = immRetailLoan.get('visibleStep');
        const customData = {
            categoriaEvento: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
            accionEvento: isDocumentActionDownload ? OPEN_MARKET_DOCUMENT_DOWNLOAD_EVENT_TAG : OPEN_MARKET_DOCUMENT_PRINT_EVENT_TAG,
            etiquetaEvento: immSelectedItem.get('title'),
            pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
            ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
        };

        recordLinkV2(customData);
        isDocumentActionDownload ? onDownloadDocument() : onPrintDocument();
    }
    handleDocumentReaded() {
        const { checkReadDocument } = this.props;
         checkReadDocument()
    }
    handleAgreeCheckModal() {
        const { checkCheckedDocument, immRetailLoan } = this.props;
        const agreeIneCheckbox = immRetailLoan.get('agreeIneCheckbox')
        checkCheckedDocument(agreeIneCheckbox)
    }
    buildCheckbox() {
        const {
            validate,
            immRetailLoan
        } = this.props;
        const checkboxFlag = immRetailLoan.get('checkboxDisabled');
        const errorLoading = immRetailLoan.get('errorEasyLoanIneDocument');
        const agreeIneCheckbox = immRetailLoan.get('agreeIneCheckbox')
         const errorState = (validate && !agreeIneCheckbox);
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');

        const checkbox = (
            <div>
                <OKCheckbox
                    extraClass="contract-loan-pdf-viewer__checkbox"
                    disabled={checkboxFlag}
                    errorMessage={errorMessage}
                    errorState={errorState}
                    idName="contract-loan-pdf-viewer-checkbox"
                    label={<FormattedText value={translationContractLoanPdfViewerINE.PDF_CHECKBOX} />}
                    onChange={this.handleAgreeCheckModal}
                    value={agreeIneCheckbox || checkboxFlag}
                />
            </div>
        )

        return !errorLoading || checkboxFlag ? checkbox : null;
    }
    handleOnDownloadDocument() {
        const { immRetailLoan } = this.props;
        const document = immRetailLoan.get('fileRetailLoanINEDocument');
        download(document, INE_DOCUMENT_NAME, 'application/pdf');

    }
    handleOnPrintDocument() {
        const { immRetailLoan } = this.props;
        const document = immRetailLoan.get('fileRetailLoanINEDocument');
        if (document) {
            openBase64pdfInPrintWindow(document);
        }
    }
    newBuildViewer() {
        const { immRetailLoan, } = this.props;
        const documents = immRetailLoan.get('fileRetailLoanINEDocument');
        const scrollDown = immRetailLoan.get('scrollDown')
        const poeditorPrefix = 'contractEasyLoanStepThree';
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_title`);
        const checkbox = scrollDown && this.buildCheckbox();

        return (
            <>
                <OKPdfViewer
                    title={title}
                    onDownload={() => this.handleOnDownloadDocument()}
                    onPrint={this.handleOnPrintDocument}
                    pdfFile={documents}
                    displayScrollButton
                    scale={1}
                    infiniteScroll={false}
                    onDocumentReaded={this.handleDocumentReaded}

                />
                {checkbox}

            </>
        )
    }
    buildContent() {
        const newPdfViewer = this.newBuildViewer();

        return (
            <div className="col-xs-12">
                <div className="retail-loan-step-three__content">
                    {newPdfViewer}
                </div>
            </div>
        );
    }

    render() {
        const content = this.buildContent();

        return (
            <div className="retail-loan-step-three">
                <div className="retail-loan-step-three__title">
                    <FormattedText value="contractRetailLoanStepThree-title" />
                </div>
                <div className="retail-loan-step-three__subtitle">
                    <FormattedText value="contractRetailLoanStepThree-subtitle" />
                </div>
                <div className="row">
                    {content}
                </div>
            </div>
        );
    }
}

RetailLoanStepThree.propTypes = {
    email: PropTypes.string,
    downloanRetailLoanContractDocument: PropTypes.func.isRequired,
    downloadINEDocument: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    processRequestConfiguration: PropTypes.func.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    resetAgreeThirdStep: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
};

module.exports = RetailLoanStepThree;
